import { NgStyle } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressBarModule, NgStyle],
})
export class ProgressBarComponent {
  @Input() loading = false;
}
